var _defs, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRookieStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rkk-s",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1,
    stdDeviation: 0.9,
    floodColor: "#1A8028",
    floodOpacity: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#rkk-s)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 9.5,8.6 12,1.5",
    fill: "#90D59B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 12,1.5 14.5,8.6",
    fill: "#22AC38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 14.5,8.6 22,8.8",
    fill: "#22AC38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 22,8.8 16,13.3",
    fill: "#90D59B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 16,13.3 18.2,20.5",
    fill: "#90D59B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 18.2,20.5 12,16.2",
    fill: "#22AC38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 12,16.2 5.8,20.5",
    fill: "#22AC38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 5.8,20.5 8,13.3",
    fill: "#90D59B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 8,13.3 2,8.8",
    fill: "#90D59B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,12 2,8.8 9.5,8.6",
    fill: "#22AC38"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12,1.5 11.2,4.8 12.8,4.8",
    fill: "#BDE6C3",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRookieStar);
export default __webpack_public_path__ + "static/media/rookie-star.b1c1c10f99c5787c2e6c5d3daf68d355.svg";
export { ForwardRef as ReactComponent };